import { formatNumber } from '../../../utils/number';
import styles from './WeightValue.module.scss';

interface WeightValueProps {
    grams: number | null;
}

export function WeightValue({ grams }: WeightValueProps) {
    if (grams === null) {
        return <span className={styles.empty}>не задан</span>;
    }

    return <>{formatNumber(grams)}</>;
}
